import homeView from './views/TemplateHome';
import overviewView from './views/TemplateOverview';
import defaultView from './views/TemplateDefault';
import agendaView from './views/TemplateAgenda';
import newsView from './views/TemplateNews';
import eventSingleView from './views/SingleEvent';
import newsSingleView from './views/SingleNews';
import t404View from './views/404';

export default [homeView, overviewView, t404View, defaultView, agendaView, newsView, eventSingleView, newsSingleView];


